import * as Switch from "@radix-ui/react-switch";
import { useId } from "react";
import { cn } from "../../../util/classNameConstructor";

export default ({ id, className, ...props }: Switch.SwitchProps) => {
  const uid = useId();
  return (
    <Switch.Root
      className={cn(
        "group/switch relative h-5 w-9 cursor-default rounded-full data-[state=checked]:bg-green-600 bg-palette-neutral-400 focus-visible:ring-2 focus-visible:ring-focused-black ring-inset",
        !props.disabled &&
          "cursor-pointer hover:bg-palette-neutral-500 data-[state=checked]:hover:bg-green-700",
        props.disabled && "opacity-50 cursor-not-allowed",
        className,
      )}
      id={id || uid}
      style={
        {
          "-webkit-tap-highlight-color": "rgba(0, 0, 0, 0)",
        } as React.CSSProperties
      }
      {...props}
    >
      <Switch.Thumb
        className={cn(
          "block size-4 m-0.5 rounded-full bg-surface-default transition-transform duration-500 will-change-transform data-[state=checked]:translate-x-4 ease-expressive-out",
          "shadow-md shadow-black/20",
          !props.disabled &&
            "group-active/switch:scale-90 group-active/switch:shadow-base",
        )}
      />
    </Switch.Root>
  );
};
